/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectedRunEnd } from '../../models/projected-run-end';

export interface GetProjectedRunEnd$Params {
  productionOrderId: number;
}

export function getProjectedRunEnd(http: HttpClient, rootUrl: string, params: GetProjectedRunEnd$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectedRunEnd>> {
  const rb = new RequestBuilder(rootUrl, getProjectedRunEnd.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectedRunEnd>;
    })
  );
}

getProjectedRunEnd.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetProjectedRunEnd';
